import { useState } from "react";
import { Link } from "react-router-dom";
import "./Subscriptions.prefix.css";
import { tierName } from "../reuse/tiers";

// A gentle, animated line that there is more on a higher type: shown in a
// few places only, dismissed with one click, remembered on this browser,
// and never a stub of the thing itself.
const KEY = "afri.subscription.hint";

const dismissed = (id) => {
  try {
    return (localStorage.getItem(KEY) || "").split(",").includes(id);
  } catch {
    return false;
  }
};

const dismiss = (id) => {
  try {
    const had = (localStorage.getItem(KEY) || "").split(",").filter(Boolean);
    localStorage.setItem(KEY, [...new Set([...had, id])].join(","));
  } catch {
    // nothing to remember with: the hint shows again next time
  }
};

export const SubscriptionHint = ({ id, children }) => {
  const [gone, setGone] = useState(() => dismissed(id));
  if (gone) return null;
  return (
    <p className="lsf-subs__hint" data-testid={`subscription-hint-${id}`}>
      <i className="lsf-subs__pulse" aria-hidden="true" />
      <span>
        {children} <Link to="/organization/subscription">See the types.</Link>
      </span>
      <button
        type="button"
        className="lsf-subs__hint-close"
        aria-label="Not now"
        onClick={() => {
          dismiss(id);
          setGone(true);
        }}
      >
        ×
      </button>
    </p>
  );
};

// On the Analytics page's Overview, where More insights would be.
export const insightsHintPanel = {
  key: "subscription-hint-insights",
  section: "overview",
  component: () => (
    <SubscriptionHint id="insights">
      More panels on every section of this page come with {tierName("team")}.
    </SubscriptionHint>
  ),
};

// On a project's Export page, where Releases would be.
export const releasesHintCard = {
  id: "subscription-hint-releases",
  component: () => (
    <SubscriptionHint id="releases">
      Numbered releases with a datasheet, licence and citation come with {tierName("team")}.
    </SubscriptionHint>
  ),
};
